export default __webpack_public_path__ + "static/media/03.ee99c7ae.wav";